var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center text-5xl overflow-hidden select-none screen-height"},[_vm._v(" "+_vm._s(_vm.$t('appEmoji'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }